import axios from 'axios'
import {
  customerCollectionFormApi,
  azureMarketplaceServiceUrl,
  customerCollectionFormApiGcp,
} from '../utils/constants'
import { CloudType } from '../modules/types'
export const API = axios.create()

const getCloudURL = (cloudProvider: string) => {
  let cloudUrl: string
  switch (cloudProvider) {
    case CloudType.GCP:
      cloudUrl = customerCollectionFormApiGcp
      break
    default:
      cloudUrl = customerCollectionFormApi
  }
  return cloudUrl
}

export const fetchCustomerCollectionData = (
  buyerId: string,
  cloudProvider: string,
  getBuyerDetails: boolean,
  labraProductId?: string
) => {
  const cloudUrl: string = getCloudURL(cloudProvider)
  const params: Record<string, string | boolean> = {
    buyer_id: buyerId,
    get_buyer_details: getBuyerDetails,
  }
  if (labraProductId) {
    params.labra_product_id = labraProductId
  }
  return API.get(`${cloudUrl}/buyer_form`, {
    params: params,
  })
}

export const submitCustomerCollectionData = (
  data: unknown,
  buyerId: string,
  cloudProvider: string,
  labraProductId?: string
) => {
  const cloudUrl: string = getCloudURL(cloudProvider)
  const params: Record<string, string> = {
    buyer_id: buyerId,
  }
  if (labraProductId) {
    params.labra_product_id = labraProductId
  }
  return API.post(`${cloudUrl}/buyer_form`, data, {
    params: params,
  })
}

export const fetchCustomerCollectionAzure = (
  buyerId: string,
  subscriptionId: string
) =>
  API.get(
    `${azureMarketplaceServiceUrl}/buyers/${buyerId}/subscriptions/${subscriptionId}`
  )

export const submitCustomerCollectionDataAzure = (
  data: unknown,
  buyerId: string,
  subscriptionId: string
) =>
  API.post(
    `${azureMarketplaceServiceUrl}/buyers/${buyerId}/subscriptions/${subscriptionId}/activate`,
    data
  )
